"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRequestError = void 0;
class HttpRequestError extends Error {
    constructor(message, status, cause) {
        super(message);
        this.message = message;
        this.status = status;
        this.cause = cause;
        if (cause) {
            this.cause = cause;
        }
    }
}
exports.HttpRequestError = HttpRequestError;
class FetchHttpClient {
    constructor(apiEndpoints, timeout) {
        this.apiEndpoints = apiEndpoints;
        this.timeout = timeout;
    }
    async getUniversalFlagConfiguration() {
        const url = this.apiEndpoints.ufcEndpoint();
        return await this.rawGet(url);
    }
    async getBanditParameters() {
        const url = this.apiEndpoints.banditParametersEndpoint();
        return await this.rawGet(url);
    }
    async getPrecomputedFlags(payload) {
        const url = this.apiEndpoints.precomputedFlagsEndpoint();
        return await this.rawPost(url, payload);
    }
    async rawGet(url) {
        try {
            // Canonical implementation of abortable fetch for interrupting when request takes longer than desired.
            // https://developer.chrome.com/blog/abortable-fetch/#reacting_to_an_aborted_fetch
            const controller = new AbortController();
            const signal = controller.signal;
            const timeoutId = setTimeout(() => controller.abort(), this.timeout);
            const response = await fetch(url.toString(), { signal });
            // Clear timeout when response is received within the budget.
            clearTimeout(timeoutId);
            if (!response?.ok) {
                throw new HttpRequestError('Failed to fetch data', response?.status);
            }
            return await response.json();
        }
        catch (error) {
            if (error.name === 'AbortError') {
                throw new HttpRequestError('Request timed out', 408, error);
            }
            else if (error instanceof HttpRequestError) {
                throw error;
            }
            throw new HttpRequestError('Network error', 0, error);
        }
    }
    async rawPost(url, payload) {
        try {
            const controller = new AbortController();
            const signal = controller.signal;
            const timeoutId = setTimeout(() => controller.abort(), this.timeout);
            const response = await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
                signal,
            });
            clearTimeout(timeoutId);
            if (!response?.ok) {
                const errorBody = await response.text();
                throw new HttpRequestError(errorBody || 'Failed to post data', response?.status);
            }
            return await response.json();
        }
        catch (error) {
            if (error.name === 'AbortError') {
                throw new HttpRequestError('Request timed out', 408, error);
            }
            else if (error instanceof HttpRequestError) {
                throw error;
            }
            throw new HttpRequestError('Network error', 0, error);
        }
    }
}
exports.default = FetchHttpClient;
//# sourceMappingURL=http-client.js.map